import {
  LockerBankSummary,
  LockerBankSummaryPagedList,
  LockerBanksListParams,
  LockerCellSizeAvailability,
  PieceLockerAccessCode,
  PieceLockerAccessCodeResponse,
  PieceLockersDetail,
  PieceLockersDetailResponse,
  UpdateLockerBankRequest,
} from '@rdTypes/apiLockers';

import { lockersApi } from './index';

type LockersPayload = { pieceId: string | number; lockersProviderType: string };

export interface UpdateLockerBankRequestExtended extends UpdateLockerBankRequest {
  id: number | string;
}

const productApi = lockersApi.injectEndpoints({
  endpoints: (builder) => ({
    getDetails: builder.query<PieceLockersDetail, LockersPayload>({
      query: ({ pieceId, lockersProviderType }) =>
        `Lockers/Detail/${pieceId}?lockersProviderType=${lockersProviderType}`,
      transformResponse: (response: PieceLockersDetailResponse) => response.objectData,
    }),
    getAccessCode: builder.query<PieceLockerAccessCode, LockersPayload>({
      query: ({ pieceId, lockersProviderType }) =>
        `Lockers/AccessCode/${pieceId}?lockersProviderType=${lockersProviderType}`,
      transformResponse: (response: PieceLockerAccessCodeResponse) => response.objectData,
    }),
    getLockersBanks: builder.query<LockerBankSummaryPagedList, LockerBanksListParams>({
      query: (params) => ({
        url: '/locker-banks',
        params,
      }),
      providesTags: ['lockerBanks'],
    }),
    getLockersByUserId: builder.query<LockerBankSummary[], number | string>({
      query: (userId) => ({
        url: `/locker-banks/users/${userId}`,
      }),
      providesTags: ['lockerBanks'],
    }),
    getAllLockersBanksMap: builder.query<{ [key: number]: LockerBankSummary }, void>({
      query: () => ({
        url: '/locker-banks',
        params: {
          'Paging.ItemsPerPage': 1000000,
          'Paging.PageNumber': 0,
        },
      }),
      providesTags: ['lockerBanks'],
      transformResponse: (response: LockerBankSummaryPagedList) =>
        response.items?.reduce<{ [key: number]: LockerBankSummary }>((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}) || {},
    }),
    updateLockerBank: builder.mutation<void, UpdateLockerBankRequestExtended>({
      query: ({ id, ...body }) => ({
        url: `/locker-banks/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['lockerBanks'],
    }),
    getLockerCellsSizes: builder.query<LockerCellSizeAvailability[], number | string>({
      query: (lockerId) => ({
        url: `/locker-banks/${lockerId}/cell-sizes`,
      }),
    }),
  }),
});

export const {
  useGetDetailsQuery,
  useGetAccessCodeQuery,
  useGetLockersBanksQuery,
  useUpdateLockerBankMutation,
  useGetAllLockersBanksMapQuery,
  useGetLockersByUserIdQuery,
  useGetLockerCellsSizesQuery,
} = productApi;
